// Helper to safely extract error payload for global error dialog
export interface ErrorPayload {
  message: string;
  header?: string;
  timestamp: number;
  redirectUrl?: string;
}

export function toErrorPayload(ex: any): ErrorPayload {
  return {
    message: ex && typeof ex.message === "string" ? ex.message : String(ex),
    header: ex && typeof ex.header === "string" ? ex.header : undefined,
    timestamp: Date.now(),
    redirectUrl: ex && typeof ex.redirectUrl === "string" ? ex.redirectUrl : undefined,
  };
}
